export const ModifierKeys = {
  CONTROL: "modiferKeyControl",
  COMMAND: "modiferKeyControl",
  SHIFT: "modiferKeyControl",
  ALT: "modiferKeyControl"
};

export const getModifierKeysForEvent = e => {
  return {
    CONTROL: e.ctrlKey,
    COMMAND: e.metaKey,
    SHIFT: e.shiftKey,
    ALT: e.altKey
  };
};

export const hasMultipleModifiers = e => {
  const keysMap = getModifierKeysForEvent(e);
  return Object.values(keysMap).reduce((count, v) => (count += v ? 1 : 0)) > 1;
};
